export const INVENTORY_TEMPLATE_PATH = '/resources/Market_Shop_Inventory_Template.csv'
export const MAX_UPLOAD_FILE_SIZE = 10 * 1024 * 1024 // 10MB
